<template>
    <div class="page-container">
        <div class="page-container-height">
          <a-tabs default-active-key="1" class="set-tabpane" @change="changeTab">
              <a-tab-pane key="1">
                  <div slot="tab" class="tab-title">
                      <img src="@/assets/image/gerenziliao.png" v-if="tabIndex == 1"/>
                      <img src="@/assets/image/gerenziliao1.png" v-else />
                      <span>个人资料</span>
                  </div>
                <div class="tabpane-content">
                    <div class="tabpane-item">
                        <div class="tabpane-item-left">真实姓名：</div>
                        <div class="tabpane-item-right">{{userObj.realName}}</div>
                    </div>
                    <div class="tabpane-item">
                        <div class="tabpane-item-left">登录账号：</div>
                        <div class="tabpane-item-right">
                            <span class="tabpane-item-right-title">{{userObj.loginName}}</span>
                            <span class="tabpane-item-set" @click="onPageModel(1)">设置</span>
                        </div>
                    </div>
                    <div class="tabpane-item">
                        <div class="tabpane-item-left">手机号：</div>
                        <div class="tabpane-item-right">
                            <span class="tabpane-item-right-title">{{userObj.mobile}}</span>
                            <span class="tabpane-item-set" @click="onPageModel(2)">修改手机号</span>
                        </div>
                    </div>
                    <div class="tabpane-item">
                        <div class="tabpane-item-left">系统角色：</div>
                        <div class="tabpane-item-right">{{userObj.roleName}}</div>
                    </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2">
                  <div slot="tab" class="tab-title">
                      <img src="@/assets/image/mima2.png" v-if="tabIndex == 2"/>
                      <img src="@/assets/image/mima1.png" v-else/>
                      <span>修改密码</span>
                  </div>
                  <div class="tabpane-content" style="padding: 70px 0 0 0">
                      <a-form :form="form"
                              :label-col="{ span: 2 }"
                              :wrapper-col="{ span: 6 }"
                      >
                          <a-form-item label="手机号">
                              <a-input placeholder="请输入手机号"
                                       type="number"
                                       autocomplete="off"
                                       ref="inputMobile"
                                       :maxLength="11"
                                       :disabled="true"
                                       v-decorator="['mobile', { rules: [{ required: true, message: '请输入手机号' }] }]" />
                          </a-form-item>
                          <a-form-item label="验证码"
                                       class="verification-code">
                              <a-input placeholder="请输入验证码" style="width: 320px"
                                       type="number"
                                       autocomplete="off"
                                       v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入验证码' }] }]" />
                              <div class="basic-code" :class="numberInput.length == 11 ? 'basic-code-active' :''" @click="btnVerificationCode">{{ time>0?time+'S后重试' :'获取验证码' }}</div>
                          </a-form-item>
                          <a-form-item label="新密码">
                              <a-input-password placeholder="请输入新密码"
                                       type="number"
                                       v-decorator="['password', { rules: [{ required: true, message: '请输入新密码' }] }]"
                                       autocomplete="new-password"
                              />
                          </a-form-item>
                          <a-form-item label="确认新密码" class="verification-code1">
                              <a-input-password placeholder="请再次输入新密码"
                                       type="number" autocomplete="new-password"
                                       v-decorator="['password1', { rules: [{ required: true, message: '请再次输入新密码' }] }]" />
                              <div class="set-pass-warn" v-if="ispass" >两次密码不同，请重新输入</div>
                          </a-form-item>
                      </a-form>
                      <div class="button-box">
                          <a-button type="primary" @click="handleSubmit">保存</a-button>
                      </div>
                  </div>
              </a-tab-pane>
          </a-tabs>
          <setPassModel ref="setPassModel" @confirmModel="confirmModel"></setPassModel>
        </div>
  </div>
</template>
<script>
    import setPassModel from './modules/setPassModel'
    import {sendCode,updateset,findCustomer} from "@/utils/api";
export default {
  name: 'setpassword',
  data () {
    return {
      form: this.$form.createForm(this),
        tabIndex:1,
        numberInput:'',
        timer: null,
        time: 0,
        ispass:false,
        userObj:{},
        verifyKey:'',
    }
  },
    mounted(){
      this.getList()
    },
  components:{
      setPassModel,
  },
  methods: {
      getList(){
          let data = new FormData()
          data.append('companyStoreId',this.$store.state.shopId)
          findCustomer(data,{}).then((res)=>{
              if(res.success){
                this.userObj = res.result
                  this.numberInput = this.userObj.mobile
                this.$store.state.userInfo.loginName = res.result.loginName
              }
          })
      },
    // 提交
    handleSubmit (e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
            if(values.password != values.password1){
                this.ispass = true
                return;
            }
            this.ispass = false
            updateset({
                companyStoreId:this.$store.state.shopId,
                mobile:values.mobile.replace(/^\s*|\s*$/g, ""),
                password:this.$md5(values.password.replace(/^\s*|\s*$/g, "")),
                tagType:3,
                verifyCode:values.verifyCode.replace(/^\s*|\s*$/g, ""),
                verifyKey:this.verifyKey,
            },{}).then((res)=>{
                if(res.success){
                    this.getList()
                    this.$message.warn(res.logMessage)
                    this.form = this.$form.createForm(this)
                }else{
                    this.$message.warn(res.logMessage)
                }
            })
        }
      })
    },
      changeTab(value){
          this.tabIndex = value
          if(value == 2){
              this.$nextTick(()=>{
                  this.form.setFieldsValue({
                      mobile:this.userObj.mobile
                  })
              })
              this.numberInput = this.userObj.mobile
          }
      },
      onPageModel(index){
          this.$refs.setPassModel.show(index)
      },
      confirmModel(value,verifyKey,index){
          let data = {}
          if(index == 1){
              data = {
                  companyStoreId:this.$store.state.shopId,
                  loginName:value.loginName,
                  tagType:index,
              }
          }else{
              data = {
                  companyStoreId:this.$store.state.shopId,
                  loginName:value.loginName,
                  mobile:value.mobile,
                  password:this.$md5(value.password),
                  tagType:index,
                  verifyCode:value.verifyCode,
                  verifyKey:verifyKey,
              }
          }
          updateset(data,{}).then((res)=>{
              if(res.success){
                  this.getList()
                  this.$refs.setPassModel.onCancel1()
                  this.time = 0
              }else{
                  this.$message.warn(res.logMessage)
              }
          })

      },
      /**
       * @description: 获取验证码（方法描述）
       */
      btnVerificationCode(){
          if(this.numberInput.length != 11){
              return
          }
          if(!this.timer){
              if(!this.isEmpty(this.numberInput)){
                  let data = new FormData()
                  data.append('mobile',this.numberInput)
                  sendCode(data,{
                      token:''
                  }).then((res)=>{
                      if(res.success){
                          this.verifyKey = res.result.key
                          this.$message.success('信息已经发到您的手机上了~')
                          this.resetTime()
                      }
                  })
              }else{
                  this.$message.warn('请输入手机号')
              }
          }else{
              this.$message.success('信息已经发到您的手机上了~')
          }
      },
      resetTime(){
          this.time = 60
          this.timer = setInterval(()=>{
              if(this.time > 0){
                  this.time--
              }else{
                  clearInterval(this.timer)
                  this.timer = null
                  this.time = 0
              }
          },1000)
      },
  }
}
</script>
<style lang="scss">
    .set-tabpane{
        .ant-tabs-bar{
            border-bottom: none !important;
        }
        .ant-tabs-ink-bar{
            display: none !important;
        }
        .ant-tabs-tab-active{
            span{
                color:#387BFC !important;
            }
        }
        .verification-code{
            .ant-form-item-children{
                display: flex;
            }
        }
    }
</style>
<style scoped lang="scss">
    .page-container-height{
        background: #ffffff;
    }
    .set-tabpane{
        padding: 56px 53px;
        .tab-title{
            color: #919191;
            font-size: 16px;
            img{
                width: 32px;
                margin-right: 10px;
            }
        }
        .tabpane-content{
            padding: 70px 0 0 66px;
            .tabpane-item{
                display: flex;
                align-items: center;
                margin-bottom: 44px;
                .tabpane-item-left{
                    width: 100px;
                    text-align: right;
                }
                .tabpane-item-right{
                    margin-left: 23px;
                    display: flex;
                    .tabpane-item-set{
                        margin-left: 40px;
                        color: #387BFC;
                        cursor: pointer;
                    }
                    .tabpane-item-right-title{
                        display: inline-block;
                        width: 200px;
                    }
                }
            }
        }
    }
    .set-pass-warn{
        position: absolute;
        bottom: -10px;
        right: -190px;
        color: #ff0000;
    }
    .basic-code{
        width:106px;
        height:36px;
        line-height: 36px;
        background:rgba(250,250,250,1);
        border:1px solid rgba(229,229,229,1);
        border-radius:6px;
        color: #AAAAAA;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
    }
    .basic-code-active{
        background-color: var(--co);
        color: #fff;
    }
    .button-box{
        margin-top: 70px;
        margin-left: 130px;
    }
</style>
